import moment from 'moment-timezone'

const URL_PATTERN =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/

export const openFile = (url, newWindow = true) => {
  const newWin = window.open(url)
  if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
    window.open(url, newWindow ? '_blank' : undefined)
  }
}

export const sleep = async (sec) =>
  new Promise((resolve) => {
    setTimeout(resolve, sec * 1000)
  })

export const dateToISOStringIncludingTimezone = (date) => {
  return moment(date).format()
}

export const isValidUrl = (url) => URL_PATTERN.test(url)

export const routeToPaymentTransactions = (item, reference) => {
  const status = item.paymentTransactionProcessedPeriodEndDate
    ? 'PAST'
    : 'EXPECTED'
  return {
    name: 'payment-transactions',
    query: { reference, status }
  }
}

export const replacePaymentPeriodHeader = (
  headers,
  tenantPaymentTransactionsConfig
) => {
  const periodHeader = headers.find(
    (header) => header.text === 'PAYMENT TRANSACTION PERIOD'
  )
  const transactionPeriod = tenantPaymentTransactionsConfig.transactionPeriod
  const setPeriodHeaderText = (text) => {
    periodHeader.text = text
    if (periodHeader.title != null) periodHeader.title = text
  }

  if (periodHeader && transactionPeriod) {
    switch (transactionPeriod) {
      case 'P1D':
        setPeriodHeaderText('PAYMENT TRANSACTION DAY')
        break
      case 'P7D':
        setPeriodHeaderText('PAYMENT TRANSACTION WEEK')
        break
    }
  }
}
